export default (value: boolean) => {
    if (value) {
        return 'Yes';
    }
    return 'No';

}